import FixtureCardFourthSlot from './fixtureCardFourthSlot.component';

export * from './fixtureCardFourthSlot.types';
export default FixtureCardFourthSlot;
